<template>
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_14085_5109)">
      <path d="M6 9.31348L13.7782 1.5353" stroke="#0017A8" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
      <path d="M8.34315 1.34315L14 1.34315L14 7" stroke="#0017A8" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" />
      <path d="M6.54545 4H2V14H12V9" stroke="#0017A8" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_14085_5109">
        <rect fill="white" height="16" width="16" />
      </clipPath>
    </defs>
  </svg>
</template>
